<template>
  <mdb-container class="gp-has-header" fluid>
    <mdb-card v-if="rssAddDialog">
      <mdb-card-body>
        <mdb-input v-model="rssFeedUrl" placeholder="RSS URL"
                   @keydown.native="addKeydown"
                   label="Add a New Feed" icon="browser"/>

        <div class="text-left">
          <mdb-btn :disabled="!rssFeedUrl" @click="saveFeed" size="sm" icon="plus-circle" color="success" rounded>Add
          </mdb-btn>
          <mdb-btn @click="rssAddDialog = false" size="sm" icon="minus-circle" color="warning" rounded>Cancel</mdb-btn>
        </div>

      </mdb-card-body>
    </mdb-card>
    <div v-if="!rssAddDialog">
      <mdb-card>
        <mdb-card-body>
          <mdb-input v-model="rssQuery" placeholder="Feed to Find"
                     @keydown.native="searchKeydown"
                     label="Search" icon="search"/>
          <mdb-btn :disabled="!rssQuery" @click="loadRss" size="sm" icon="search" color="secondary" rounded>Go</mdb-btn>
          <mdb-btn @click="resetRss" size="sm" icon="minus-circle" color="warning" rounded>Reset</mdb-btn>
          <mdb-btn @click="rssAddDialog=true" icon="plus-circle" rounded size="sm" color="success">Add a New Feed
          </mdb-btn>
        </mdb-card-body>
      </mdb-card>
      <h3>Select a Feed</h3>
      <div v-if="rssTotal > rssLimit" class="text-center">
        <mdb-btn @click="prevRss" :disabled="rssOffset == 0" icon="arrow-left" size="sm" rounded/>
        <mdb-btn @click="nextRss" :disabled="rssOffset > (rssTotal - rssLimit)" icon="arrow-right"
                 size="sm" rounded/>
      </div>
      <mdb-row v-if="rssFeeds.length>0">
        <div v-for="(f,i) in rssFeeds" :key="i" class="col-lg-3 col-md-12 d-flex align-self-stretch">
          <mdb-card class="mb-4" style="width:100%">
            <mdb-card-body class="text-center">
              <img v-if="f.imageUrl" :src="f.imageUrl" style="max-width:100%; max-height: 100px;"/>
              <h5 class="text-primary">{{ f.title }}
                <a href="" @click.prevent="editTitle(f)">
                  <mdb-icon icon="pencil"/>
                </a>
              </h5>
            </mdb-card-body>
            <mdb-card-footer class="text-center">
              <mdb-btn @click="togglePublic(f)" size="sm" rounded :color="f.isPublic ? 'success' : 'danger'"
                       :icon="f.isPublic ? 'eye-slash' : 'eye'">{{ f.isPublic ? 'Make Private' : 'Make Public' }}
              </mdb-btn>
              <mdb-btn @click="toggleLockTitle(f)" size="sm" rounded :color="f.lockTitle ? 'success' : 'danger'"
                       :icon="f.lockTitle ? 'lock-open' : 'lock'">{{ f.lockTitle ? 'Unlock Title' : 'Lock Title' }}
              </mdb-btn>
              <mdb-btn @click="clearCache(f)" size="sm" rounded color="danger" icon="trash">Clear Cache</mdb-btn>
              <mdb-btn @click="changeImage(f)" size="sm" rounded color="warning" icon="image">Change Image</mdb-btn>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </mdb-row>

    </div>

    <mdb-modal :show="editModal" size="md" @close="editModal=false">
      <mdb-modal-header center class="primary-color-dark text-white">
        <h5>New Title</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input v-model="newTitle" label="Title"/>
        <mdb-btn @click="saveTitle" color="success" icon="save" size="sm" rounded>Save</mdb-btn>
        <mdb-btn @click="editModal=false" color="danger" icon="minus-circle" size="sm" rounded>Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="imageModal" size="md" @close="imageModal=false">
      <mdb-modal-header center class="primary-color-dark text-white">
        <h5>New Image</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="small">
          Only change the image if the feed doesn't provide one. Any image you load will be overridden the next time
          the feed is loaded, usually 15 minutes.
        </div>
        <mdb-file-input v-on:getValue="uploadImage"/>
        <mdb-btn @click="imageModal=false" color="danger" icon="minus-circle" size="sm" rounded>Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbFileInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from "mdbvue";
import YesNoModal from "../common/YesNoModal";

export default {
  name: "admin-rss-feeds",
  components: {
    YesNoModal,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbInput,
    mdbChip,
    mdbIcon,
    mdbBtn,
    mdbFileInput,
    mdbBadge,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbTbl,
    mdbTblHead,
    mdbTblBody
  },
  data() {
    return {
      rssLimit: 20,
      rssFeeds: [],
      rssFeedUrl: "",
      rssTotal: 0,
      rssOffset: 0,
      rssQuery: null,
      rssAddDialog: false,
      newTitle: "",
      editModal: false,
      editFeed: null,
      image: null,
      imageModal: false
    };
  },
  mounted() {
    this.loadRss()
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  methods: {
    uploadImage: function(file) {
      this.imageModal = false
      this.$store.dispatch("setExecuting", true)
      api.postImage("/rssFeed/uploadImage/" + this.editFeed.id, file[0]).then(
        (results) => {
          this.editFeed.imageUrl = results.data.imageUrl
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    changeImage: function(feed) {
      this.editFeed = feed
      this.imageModal = true
    },
    editTitle: function (feed) {
      this.newTitle = feed.title
      this.editModal = true
      this.editFeed = feed
    },
    prevRss: function () {
      this.rssOffset -= this.rssLimit
      this.loadRss()
    },
    nextRss: function () {
      this.rssOffset += this.rssLimit
      this.loadRss()
    },
    resetRss: function () {
      this.rssQuery = "";
      this.loadRss();
    },
    searchKeydown: function (e) {
      if (e.keyCode == 13 && this.rssQuery) this.loadRss();
    },
    addKeydown: function (e) {
      if (e.keyCode == 13 && this.rssFeedUrl) this.saveFeed();
    },
    loadRss: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/list", {
        offset: this.rssOffset, max: this.rssLimit,
        query: this.rssQuery, showAll: true
      }).then(
        (results) => {
          this.rssFeeds = results.data.rows
          this.rssTotal = results.data.totalCount
        },
        (error) => {
          this.$notify.error({
                               message: "Could not load RSS Feeds.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveFeed() {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/addFeed", {url: this.rssFeedUrl}).then(
        (results) => {
          this.rssFeeds.unshift(results.data)
          this.rssAddDialog = false
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    togglePublic(feed) {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/togglePublic", feed).then(
        () => {
          feed.isPublic = !feed.isPublic
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleLockTitle(feed) {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/toggleLockTitle", feed).then(
        () => {
          feed.lockTitle = !feed.lockTitle
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveTitle() {
      this.editModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/updateTitle", {id: this.editFeed.id, title: this.newTitle}).then(
        () => {
          this.editFeed.lockTitle = true
          this.editFeed.title = this.newTitle
        },
        (error) => {
          this.editModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    clearCache(feed) {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/clearCache", {id: feed.id}).then(
        () => {
          this.$notify.success({message: "Cache Cleared", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style scoped></style>
